<template>
  <div>
    <form role="form">
      <div class="box-body">
        <div class="form-group">
          <label for="name">Nome do Parceiro</label>
          <input type="text" class="form-control" id="name" placeholder="Entre com o nome do Parceiro" v-model="partner.name">
          <p v-if="errors.name" class="text-red">{{ errors.name }}</p>
        </div>
        <div class="form-group">
          <label for="responsible">Nome do Responsável</label>
          <input type="text" class="form-control" id="responsible" placeholder="Entre com o nome do Responsável" v-model="partner.responsible">
          <p v-if="errors.responsible" class="text-red">{{ errors.responsible }}</p>
        </div>
        <fieldset>
          <legend>Contato</legend>
          <div class="form-group">
            <label for="email">E-mail</label>
            <input type="email" class="form-control" id="email" placeholder="Entre com o email" v-model="partner.email">
            <p v-if="errors.email" class="text-red">{{ errors.email }}</p>
          </div>
          <div class="form-group">
            <label for="phone">Telefone</label>
            <the-mask
              :mask="['(##) ####-####', '(##) #####-####']"
              id="phone"
              type="text"
              :masked="true"
              placeholder="Entre com o telefone"
              class="form-control"
              v-model="partner.phone"
            />
            <p v-if="errors.phone" class="text-red">{{ errors.phone }}</p>
          </div>
        </fieldset>
      </div>
      <div class="box-footer">
        <button type="submit" class="btn btn-sm btn-primary pull-right" v-on:click.prevent="onSubmit">
          <i class="fa fa-save"></i>&nbsp; Salvar
        </button>
        <go-back-button></go-back-button>
      </div>
    </form>
  </div>
</template>

<script>
import GoBackButton from '@/components/elements/GoBackButton'
import TheMask from 'vue-the-mask'

export default {
  name: 'PartnerForm',
  components: { TheMask, GoBackButton },
  props: ['partner', 'errors', 'onSubmit']
}
</script>



// WEBPACK FOOTER //
// PartnerForm.vue?0eccc311